export enum SearchTopPromotedVerticalCardsValues {
    control = 'control',
    vertical = 'vertical',
}

export const SEARCH_TOP_PROMOTED_VERTICAL_CARDS = {
    name: 'search_top_promoted_vertical_cards',
    paramName: 'style',
    defaultValue: SearchTopPromotedVerticalCardsValues.control,
};
